import { isFlightItem } from 'lib/checkout/checkoutUtils'

export function getAgentHubExperienceType(experience: App.ExperienceOffer): App.ProductType {
  switch (experience.productType) {
    case 'transfer':
      return 'transfer'
    default:
      return 'experience'
  }
}

export function getAgentHubCommissionItemKey(item: App.Checkout.AnyItem | App.Checkout.AnyItemBreakdownView): string {
  const transactionKey = item.transactionKey

  if ('experienceId' in item && item.itemType === 'experience') {
    return transactionKey + '-' + item.experienceId
  }

  if (item.itemType === 'tourV2Experience' && 'purchasableOption' in item) {
    return item.transactionKey + '-' + item.purchasableOption.fkTourId
  }

  if ('offerId' in item) {
    return transactionKey + '-' + item.offerId
  }

  if (isFlightItem(item as App.Checkout.AnyItem)) {
    return transactionKey + '-' + (item as App.Checkout.FlightItem).flights[0]?.journeyId
  }
  return transactionKey!
}

const TIER_ORDER: Array<App.AgentHubTier> = ['tier1', 'tier2', 'tier3']

export function isAgentTierGreaterOrEqualTo(agentTier: App.AgentHubTier, requiredTier: App.AgentHubTier): boolean {
  return TIER_ORDER.indexOf(agentTier) >= TIER_ORDER.indexOf(requiredTier)
}

export const isAgencyIdentifierRequired = (currentRegionCode: string) => {
  const nonRequiredRegions = ['GB', 'US']
  return !nonRequiredRegions.includes(currentRegionCode)
}

export const mapTourVariationToAgentHubDateRangePayload = (variation: App.Tours.TourV2OfferVariation): Array<{ id: string; startDate: string; endDate: string }> => {
  return variation.departures.map(departure => ({
    id: departure.id,
    startDate: departure.startDate,
    endDate: departure.endDate,
  }))
}
